let orignDisplayStyle=''
function bindCheckPermission(el, binding) {
  let isPermission = false;
  const { value } = binding;
  const cache = localStorage.getItem('USER_INFO') || '{}';
  const memInfo = localStorage.getItem('MEM_INFO') || '{}';
  const {listPerms=[]} = JSON.parse(cache);
  const userOrgCode = JSON.parse(cache)?.orgCode;
  const memOrgCode = JSON.parse(memInfo)?.orgCode;  
  orignDisplayStyle=el.style.display
  if(value&&value.indexOf('Mem:MemInfoDetail:Update')>-1){
    if(userOrgCode === memOrgCode && listPerms.indexOf(value) > -1){
      isPermission = true
    }
  }else{
    // if(value&&listPerms.indexOf(value)>-1){
    //   isPermission = true
    // }
    isPermission = true
  }
  if (!isPermission) {
    el.style.display='none'
  }
}
function updateCheckPermission(el, binding) {
  let isPermission = false;
  const { value } = binding;
  const cache = localStorage.getItem('USER_INFO') || '{}';
  const memInfo = localStorage.getItem('MEM_INFO') || '{}';
  const {listPerms=[]} = JSON.parse(cache);
  const userRegisterNumber = JSON.parse(cache)?.orgCode;
  const memRegisterNumber = JSON.parse(memInfo)?.orgCode;
  if(value.indexOf('Mem:MemInfoDetail')>-1){
    if(userRegisterNumber===memRegisterNumber&&listPerms.indexOf(value)>-1){
      isPermission = true
    }
  }else{
    // if(listPerms.indexOf(value)>-1){
    //   isPermission = true
    // }
    isPermission = true
  }
  if (!isPermission) {
    el.style.display='none'
  }else{
    el.style.display=orignDisplayStyle
  }
}
export default {
  beforeMount(el, binding, vnode) {
    bindCheckPermission(el, binding);
  },
  updated(el, binding, vnode) {
    updateCheckPermission(el, binding);
  },
  name: 'permission'
};